<script setup>
const props = defineProps(["class"]);
</script>

<template>
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="class"
    >
        <path
            d="M2.66667 1.33301V13.333H2V14.6663H4.66667V13.333H4V9.99967H12.6667C12.8435 9.99967 13.013 9.92944 13.1381 9.80441C13.2631 9.67939 13.3333 9.50982 13.3333 9.33301V2.66634C13.3333 2.48953 13.2631 2.31996 13.1381 2.19494C13.013 2.06991 12.8435 1.99967 12.6667 1.99967H4V1.33301H2.66667ZM5.33333 3.33301V4.66634H6.66667V3.33301H8V4.66634H9.33333V3.33301H10.6667V4.66634H12V5.99967H10.6667V7.33301H12V8.66634H10.6667V7.33301H9.33333V8.66634H8V7.33301H6.66667V8.66634H5.33333V7.33301H4V5.99967H5.33333V4.66634H4V3.33301H5.33333Z"
            fill="currentColor"
        />
        <path
            d="M5.33333 5.99967H6.66667L6.66667 7.33301H5.33333V5.99967ZM8 5.99967H9.33333L9.33333 7.33301H8L8 5.99967ZM6.66667 4.66634H8L8 5.99967H6.66667L6.66667 4.66634ZM9.33333 4.66634H10.6667V5.99967H9.33333L9.33333 4.66634Z"
            fill="currentColor"
        />
    </svg>
</template>
